import React, { useEffect, useRef, useState } from "react";
import "./home_testimonial.scss";
import SectionHeader from "../section_header/SectionHeader";
import Testimonial from "../testmonial/Testimonial";
import Slider from "react-slick";

// required slick CSS (import in component or in your global CSS entry)
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const HomeTestimonial = () => {
  const [config, setConfig] = useState({
    show: 3,
    scroll: 1,
    breakpoint: "desktop",
  });

  useEffect(() => {
    const updateConfig = () => setConfig(calculateConfig());

    updateConfig(); // on mount
    window.addEventListener("resize", updateConfig);

    return () => window.removeEventListener("resize", updateConfig);
  }, []);

  const calculateConfig = () => {
    const width = window.innerWidth;

    if (width <= 480) return { show: 1, scroll: 1, breakpoint: "mobile" };

    if (width <= 768) return { show: 2, scroll: 1, breakpoint: "tablet" };

    if (width <= 1024)
      return { show: 2, scroll: 1, breakpoint: "small-desktop" };

    return { show: 3, scroll: 1, breakpoint: "desktop" };
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: config.show,
    slidesToScroll: config.scroll,
    autoplay: true,
    autoplaySpeed: 3000,
    swipeToSlide: true,
    arrows: false,
    touchMove: true,
  };

  const testmonialSlides = ["o2", "c9", "c7", "BUTTONS"];

  return (
    <div className="home_testimonial_main">
      <div className="home_testimonial_heading">
        <SectionHeader name={"TESTIMONIALS"} />
      </div>

      <div className="home_testminial_container">
        <Slider key={config.breakpoint} {...settings}>
          {testmonialSlides.map((id, idx) => (
            <div key={idx} className="slide">
              <Testimonial projectId={id} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default HomeTestimonial;
